export default () => {
    return [
        {
            path: '/stats',
            name: 'stats',
            component: () => import('./views/statistiche.vue'),
        },
    ];
};
